import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import HotelEntity from '@/js/common/Domain/Entity/Hotel';

@extendDecorator({
    defaults: {
        pool: false,
        aquapark: false,
        animation: false,
        familyRooms: false,
        diving: false,
        freeSafe: false,
        fitnessCenter: false,
        freeMiniBar: false,
        skiEquipment: false,
        honeyMoon: false,
        waterSports: false,
        spaAndHealth: false,
        nightClub: false,
        personsWithDisabilities: false,
        noSmokingRooms: false,
        smokingRooms: false,
    },
})
export default class HotelEntityExtended extends HotelEntity {}